/*
 * Copyright (c) 2019.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {Picture} from './Picture';

export interface Banner {
  id?: number;
  header: string;
  link: string;
  createdAt?: Date;
  updatedAt?: Date;
  picture?: Picture;
  enabled?: boolean;
  deleted?: boolean;
  pos: number;
}
